import * as VerificationConstants from '../constants';
import * as D from '../deps';

import * as Workers from './workers';

export default [
  {
    actionType: VerificationConstants.Actions.GET_DISCOUNT_VERIFICATION_INFO,
    handler: Workers.getDiscountVerificationInfo,
    concur: 'takeOnly',
  },
  {
    actionType: VerificationConstants.Actions.SUBMIT_DISCOUNT_VERIFICATION,
    handler: Workers.submitDiscountVerification,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.SUBMIT_DISCOUNT_VERIFICATION_SUCCESS,
    handler: Workers.onSubmitDiscountVerificationSuccess,
    concur: 'takeOnly',
  },
  {
    actionType: D.Constants.Api.ApiActions.SUBMIT_DISCOUNT_VERIFICATION_FAIL,
    handler: Workers.onSubmitDiscountVerificationFail,
    concur: 'takeOnly',
  },
  {
    actionType: VerificationConstants.Actions.DISCOUNT_ORG_SEARCH_AUTOCOMPLETE,
    handler: Workers.discountOrgSearchAutocomplete,
    concur: 'takeOnly',
  },
  {
    actionType: VerificationConstants.Actions.REDIRECT_TO_DISCOUNT_VERIFICATION,
    handler: Workers.redirectToDiscountVerification,
    concur: 'takeOnly',
  },
];
